import { useQuery } from "@tanstack/react-query";
import * as req from "@script/req.ts";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

export function useRosterLatestQuery(groupId: string | null) {
  return useQuery({
    queryKey: QUERY_KEYS.roster.latest(groupId),
    queryFn: async () => {
      return await req.roster_latest(groupId);
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
